var map = {
	"./decidim/avatar-multiuser.png": 79730,
	"./decidim/brands/google.svg": 16061,
	"./decidim/cc-badge.png": 28524,
	"./decidim/decidim-logo.svg": 85376,
	"./decidim/default-avatar.svg": 83992,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 12644,
	"./decidim/icons.svg": 41363,
	"./decidim/pattern.png": 27972,
	"./decidim/placeholder-card-g.svg": 91537,
	"./decidim/placeholder-card-l.svg": 54714,
	"./decidim/placeholder.jpg": 23177,
	"./decidim/remixicon.symbol.svg": 24701,
	"./decidim/vendor/leaflet/layers-2x.png": 66236,
	"./decidim/vendor/leaflet/layers.png": 63563,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 34310,
	"./decidim/vendor/leaflet/marker-icon.png": 64989,
	"./decidim/vendor/leaflet/marker-shadow.png": 29394,
	"./decidim/vendor/social-share-button/douban.svg": 40012,
	"./decidim/vendor/social-share-button/email.svg": 873,
	"./decidim/vendor/social-share-button/facebook.svg": 41695,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 61793,
	"./decidim/vendor/social-share-button/hacker_news.svg": 55017,
	"./decidim/vendor/social-share-button/linkedin.svg": 60393,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 52554,
	"./decidim/vendor/social-share-button/pinterest.svg": 46639,
	"./decidim/vendor/social-share-button/reddit.svg": 68019,
	"./decidim/vendor/social-share-button/telegram.svg": 92454,
	"./decidim/vendor/social-share-button/tumblr.svg": 59205,
	"./decidim/vendor/social-share-button/twitter.svg": 70168,
	"./decidim/vendor/social-share-button/vkontakte.svg": 11990,
	"./decidim/vendor/social-share-button/wechat.svg": 78577,
	"./decidim/vendor/social-share-button/whatsapp.svg": 37657,
	"./decidim/vendor/social-share-button/x.svg": 83921,
	"./decidim/vendor/social-share-button/xing.svg": 1759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46765;